<template>
  <div class="tracking-d-index">
    <div class="t-d-i-header">
      <wb-header></wb-header>
    </div>
    <div class="t-d-i-content">
      <div class="tdw-top">
        <a-row>
          <a-col :span="12">
            <div class="tdw-t-name">工作台</div>
            <div class="tdw-t-info">欢迎进入工作台，已有平台和流程：</div>
            <div class="tdw-t-nav">
              <div class="tdw-t-navb" @click="goToUserPage('/home')">
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>Precision Diagnosis</span>
                  </template>
                  <svg class="icon svg-icon" aria-hidden="true">
                    <use xlink:href="#icon-weibiaoti-1"></use>
                  </svg>
                </a-tooltip>
              </div>
              <div class="tdw-t-navb" @click="goToUserPage('/molecular')">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Genomics Database</span>
                  </template>
                  <svg class="icon svg-icon" aria-hidden="true">
                    <use xlink:href="#icon-sangjitu"></use>
                  </svg>
                </a-tooltip>
              </div>
              <div class="tdw-t-navb" @click="goToUserPage()">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Genomics Datasharing</span>
                  </template>
                  <svg class="icon svg-icon" aria-hidden="true">
                    <use xlink:href="#icon-a-Shape2"></use>
                  </svg>
                </a-tooltip>
              </div>
              <div
                class="tdw-t-navb"
                @click="goToUserPage('http://biocloud.ronglian.com/')"
              >
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Ronglian BioCloud</span>
                  </template>
                  <svg class="icon svg-icon" aria-hidden="true">
                    <use xlink:href="#icon-rong"></use>
                  </svg>
                </a-tooltip>
              </div>
              <div
                class="tdw-t-navb tdw-t-navbgc"
                @click="goToUserPage('/analysis')"
              >
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>BALL6</span>
                  </template>
                  <svg class="icon svg-icon" aria-hidden="true">
                    <use xlink:href="#icon-BALL6"></use>
                  </svg>
                </a-tooltip>
              </div>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="fr tdw-t-useropt">
              <!-- <a-button type="primary" @click="goToUserPage('/turn/user')"
                >总控设置</a-button
              > -->
              <a-button type="primary" @click="goToUserPage('/profile')"
                >安全设置</a-button
              >
              <a-button type="primary" @click="goToUserPage('/profile')"
                >消息提醒</a-button
              >
            </div>
            <div class="fr tdw-t-userinfo">
              <div class="tdw-t-name">{{ user.nickName }}</div>
              <div class="tdw-t-info">
                角色：<span class="tdw-tinfo-c">{{ user.roleName }}</span>
              </div>
              <div class="tdw-t-info">
                组织：<span class="tdw-tinfo-c">{{ user.deptName }}</span>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
      <div class="tdw-content clearfix">
        <div class="tdw-content-top clearfix">
          <div class="fl tdw-c-statistics">
            <a-row>
              <a-col :span="8">
                <div class="tdw-cs-name">
                  <div class="tdw-icon">
                    <svg class="icon svg-icon" aria-hidden="true">
                      <use xlink:href="#icon-weibiaoti-1"></use>
                    </svg>
                  </div>
                  就诊流程
                </div>
                <div class="tdw-cs-info">
                  今日
                  <span class="tdw-cs-num"
                    >+{{ pageStatData.pitemTodayAdd }}</span
                  >
                </div>
                <div class="tdw-cs-info">
                  累计：{{ pageStatData.pitemCount }}
                </div>
              </a-col>
              <a-col :span="8">
                <div class="tdw-cs-name">
                  <div class="tdw-icon">
                    <svg class="icon svg-icon" aria-hidden="true">
                      <use xlink:href="#icon-weibiaoti-1"></use>
                    </svg>
                  </div>
                  作业管理
                </div>
                <div class="tdw-cs-info">
                  今日
                  <span class="tdw-cs-num"
                    >+{{ pageStatData.jobTodayAdd }}</span
                  >
                </div>
                <div class="tdw-cs-info">
                  排队：{{ pageStatData.jobLineUp }}
                </div>
              </a-col>
              <a-col :span="8">
                <div class="tdw-cs-name">
                  <div class="tdw-icon">
                    <svg class="icon svg-icon" aria-hidden="true">
                      <use xlink:href="#icon-weibiaoti-1"></use>
                    </svg>
                  </div>
                  报告管理
                </div>
                <div class="tdw-cs-info">
                  今日
                  <span class="tdw-cs-num"
                    >+{{ pageStatData.reportTodayAdd }}</span
                  >
                </div>
                <div class="tdw-cs-info">
                  累计：{{ pageStatData.reportCount }}
                </div>
              </a-col>
            </a-row>
          </div>
          <div class="fl tdw-c-database">
            <a-row>
              <a-col :span="8">
                <div class="tdw-cs-name">
                  <div class="tdw-icon">
                    <svg class="icon svg-icon" aria-hidden="true">
                      <use xlink:href="#icon-sangjitu"></use>
                    </svg>
                  </div>
                  数据库样本
                </div>
                <div class="tdw-cs-info">
                  累计
                  <span class="tdw-cs-num">{{ pageStatData.dbCount }}</span>
                </div>
                <div class="tdw-cs-info">
                  新增：+{{ pageStatData.dbNewAdd }}
                </div>
              </a-col>
              <a-col :span="16">
                <a-row class="tdw-cs-db-layer">
                  <a-col :span="6" v-for="(item, index) in piesData">
                    <template v-if="index == piesData.length - 1">
                      <div class="tdw-cs-name">{{ item.name }}</div>

                      <div
                        v-if="item.fullName.length > 15"
                        class="tdw-cs-info tdw-cs-info-h"
                      >
                        ({{ item.fullName }})
                      </div>

                      <div
                        v-else
                        class="tdw-cs-info tdw-cs-info-h"
                        style="line-height: 24px"
                      >
                        ({{ item.fullName }})
                      </div>
                      <div class="tdw-cs-info-dbnum">{{ item.total }}</div>
                      <div class="tdw-cs-info">{{ item.percentage }}%</div>
                    </template>
                    <template v-else>
                      <div class="tdw-cs-name">{{ item.name }}</div>
                      <div
                        v-if="item.fullName.length > 15"
                        class="tdw-cs-info tdw-cs-info-h"
                      >
                        ({{ item.fullName }})
                      </div>
                      <div
                        v-else
                        class="tdw-cs-info tdw-cs-info-h"
                        style="line-height: 24px"
                      >
                        ({{ item.fullName }})
                      </div>
                      <div class="tdw-cs-info-dbnum">{{ item.total }}</div>
                      <div class="tdw-cs-info">{{ item.percentage }}%</div>
                      <div class="tdw-cs-line"></div>
                    </template>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </div>
        </div>
        <div class="tdw-content-center">
          <a-row>
            <a-col :span="18">
              <div class="tdw-cc-left">
                <h2 class="tdw-cc-t-title tdw-cc-tnav">我的导航</h2>
                <div class="tdw-cc-group clearfix">
                  <render-menu :menuData="menus"></render-menu>
                </div>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="tdw-cc-right">
                <h2 class="tdw-cc-t-title tdw-cc-tnav">
                  <span
                    v-auth="'10903'"
                    :class="
                      barType == 'diagnosis'
                        ? 'tdw-cc-check'
                        : 'tdw-cc-check not-checked'
                    "
                    @click="tabsChartBar('diagnosis')"
                    >我的就诊流程</span
                  >
                  <span
                    v-auth="'10904'"
                    :class="
                      barType == 'report'
                        ? 'tdw-cc-check'
                        : 'tdw-cc-check not-checked'
                    "
                    @click="tabsChartBar('report')"
                    >我的报告</span
                  >
                </h2>
                <procedure-e-chart
                  v-auth="'10904'"
                  v-if="
                    !flagBar &&
                    barType == 'report' &&
                    reportStatusDataBar.barData.length > 0
                  "
                  :dataLst="reportStatusDataBar"
                ></procedure-e-chart>
                <procedure-e-chart
                  v-auth="'10903'"
                  v-if="
                    !flagBar &&
                    barType == 'diagnosis' &&
                    diagnosisStatusDataBar.barData.length > 0
                  "
                  :dataLst="diagnosisStatusDataBar"
                ></procedure-e-chart>
              </div>
            </a-col>
          </a-row>
        </div>
        <div class="tdw-content-center">
          <a-row>
            <a-col :span="12">
              <div class="tdw-cc-left tdw-cc-left-height">
                <h2 class="tdw-cc-t-title">
                  我的消息<span>({{ noteTotal }})</span>
                  <router-link class="link fr" to="/note"
                    >查看更多 <em>>></em></router-link
                  >
                </h2>
                <template v-if="noteData && noteData.length > 0">
                  <div
                    @click="message(item)"
                    v-for="item in noteData"
                    :class="
                      item.messageTitleType == 22 || item.messageTitleType == 23
                        ? 'cursor'
                        : 'cursor cursor-adline'
                    "
                  >
                    <a-row type="flex" class="tdw-cc-tlist">
                      <a-col class="tdw-cc-row" flex="70%">
                        <template
                          v-if="
                            item.messageTitleType == 22 ||
                            item.messageTitleType == 23
                          "
                        >
                          {{ mdMessageContentHtml(item) }}
                        </template>
                        <template v-else>{{ item.messageContent }}</template>
                      </a-col>
                      <a-col class="tdw-cc-time" flex="auto">
                        {{ item.createTime }}
                      </a-col>
                    </a-row>
                  </div>
                </template>
                <template v-else>
                  <a-empty />
                </template>
              </div>
            </a-col>
            <a-col :span="12">
              <div class="tdw-cc-right">
                <h2 class="tdw-cc-t-title">
                  <a-row>
                    <a-col :span="12">
                      <span
                        v-auth="'10901'"
                        :class="
                          areaType == 'diagnosis'
                            ? 'tdw-cc-check'
                            : 'tdw-cc-check not-checked'
                        "
                        @click="tabsChartArea('diagnosis')"
                        >新增就诊流程</span
                      >
                      <span
                        v-auth="'10902'"
                        :class="
                          areaType == 'report'
                            ? 'tdw-cc-check'
                            : 'tdw-cc-check not-checked'
                        "
                        @click="tabsChartArea('report')"
                        >已通过的报告</span
                      >
                    </a-col>
                    <a-col :span="12" style="text-align: right">
                      <a-range-picker
                        :disabledDate="disabledEndDate"
                        class="tool-item"
                        style="width: 198px"
                        @change="onChangePicker"
                        :value="rPrckerVal"
                      />
                    </a-col>
                  </a-row>
                </h2>
                <div class="tdw-cc-charts-main">
                  <wave-e-chart
                    v-auth="'10901'"
                    v-if="
                      areaType == 'diagnosis' &&
                      diagnosisNumArea.areaData.length > 0 &&
                      !flagArea
                    "
                    :dataLst="diagnosisNumArea"
                  ></wave-e-chart>
                  <template
                    v-auth="'10901'"
                    v-else-if="
                      areaType == 'diagnosis' &&
                      diagnosisNumArea.areaData.length == 0
                    "
                  >
                    <a-empty />
                  </template>
                  <wave-e-chart
                    v-auth="'10902'"
                    v-if="
                      areaType == 'report' &&
                      reportNumArea.areaData.length > 0 &&
                      !flagArea
                    "
                    :dataLst="reportNumArea"
                  ></wave-e-chart>
                  <template
                    v-auth="'10902'"
                    v-else-if="
                      areaType == 'report' && reportNumArea.areaData.length == 0
                    "
                  >
                    <a-empty />
                  </template>
                </div>
              </div>
            </a-col>
          </a-row>
        </div>

        <!-- <div class="tdw-content-center">
          <a-row>
            <a-col :span="18">
              <div class="tdw-cc-left">
                <h2 class="tdw-cc-t-title tdw-cc-tnav">我的分析</h2>
                <a-table
                  class="tdw-table"
                  :columns="columns"
                  size="small"
                  :data-source="data"
                  bordered
                  :pagination="false"
                  :rowKey="
                    (record, index) => {
                      return index;
                    }
                  "
                >
                  <template slot="name" slot-scope="text">
                    <a>{{ text }}</a>
                  </template>
                </a-table>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="tdw-cc-right">
                <h2 class="tdw-cc-t-title tdw-cc-tnav">我的账户</h2>
                <div class="tdw-list-progress">
                  <div class="tdw-list-progress-name">账户余额</div>
                  <a-progress :percent="30" />
                </div>
                <div class="tdw-list-progress">
                  <div class="tdw-list-progress-name">可用CPU</div>
                  <a-progress :percent="30" />
                </div>
                <div class="tdw-list-progress">
                  <div class="tdw-list-progress-name">可用存储</div>
                  <a-progress :percent="30" />
                </div>
                <div class="tdw-list-progress">
                  <div class="tdw-list-progress-name">可用GPU</div>
                  <a-progress :percent="30" />
                </div>
              </div>
            </a-col>
          </a-row>
        </div> -->
      </div>
    </div>
    <wb-footer></wb-footer>
  </div>
</template>

<script>
import moment from "moment";
import authUtils from "@/directives/auth-utils.js";
import { mapState } from "vuex";
import WbHeader from "../../components/wordbench/header.vue";
import WbFooter from "../../components/wordbench/footer.vue";
import ProcedureEChart from "@/components/wordbench/procedureEChart.vue";
import WaveEChart from "@/components/wordbench/waveEChart.vue";
import RenderMenu from "@/components/wordbench/renderMenu.vue";

const columns = [
  {
    title: "状态",
    dataIndex: "name",
  },
  {
    title: "作业名称",
    className: "column-money",
    dataIndex: "money",
  },
  {
    title: "提交人",
    dataIndex: "address",
  },
  {
    title: "审核人",
    dataIndex: "vis",
  },
];

const data = [
  {
    key: "1",
    name: "John Brown",
    money: "￥300,000.00",
    address: "New Park",
    vis: "2021-05-24 17:37:01",
  },
  {
    key: "2",
    name: "Jim Green",
    money: "￥1,256,000.00",
    address: "London",
    vis: "2021-05-24 17:37:01",
  },
  {
    key: "3",
    name: "Joe Black",
    money: "￥120,000.00",
    address: "Sidney",
    vis: "2021-05-24 17:37:01",
  },
  {
    key: "1",
    name: "John Brown",
    money: "￥300,000.00",
    address: "New Park",
    vis: "2021-05-24 17:37:01",
  },
  {
    key: "2",
    name: "Jim Green",
    money: "￥1,256,000.00",
    address: "London",
    vis: "2021-05-24 17:37:01",
  },
];
export default {
  computed: {
    ...mapState({
      user: (state) => state.account.user,
      token: (state) => state.account.token,
      avatar() {
        return `static/avatar/${this.user.avatar}`;
      },
    }),
  },
  components: {
    WbHeader,
    WbFooter,
    ProcedureEChart,
    WaveEChart,
    RenderMenu,
  },
  data() {
    return {
      data,
      noteData: [],
      noteTotal: 0,
      pageStatData: {},
      piesData: [],
      rPrckerVal: null,
      statOpt: { startTime: "", endTime: "" },
      areaType: "diagnosis",
      flagArea: false,
      reportAndTreatmentData: {},
      reportNumArea: { xAxis: [], areaData: [] },
      diagnosisNumArea: { xAxis: [], areaData: [] },
      itemStatusData: {},
      reportStatusDataBar: { yAxis: [], barData: [] },
      diagnosisStatusDataBar: { yAxis: [], barData: [] },
      itemDiagnosisStatusName: {
        uploaded: "报告已上传",
        waitUpload: "报告待上传",
        filter: "报告待筛选",
        running: "作业运行中",
      },
      itemReportStatusName: {
        notnum: "未指派",
        reviewed: "待审核",
        failed: "已提交",
        wait: "待提交",
      },
      barType: "diagnosis",
      flagBar: false,
      columns,
      menus: [],
      allMenus: [
        {
          path: "/statistics",
          name: "统计分析",
          icon: "/icon/tongjifenxi.png",
          desc: "患者记录（ 20 ）",
          subName: "Precision Diagnosis",
        },
        {
          path: "/diagnosis",
          name: "就诊流程",
          icon: "/icon/liucheng-3.png",
          subName: "Precision Diagnosis",
        },
        {
          path: "/job",
          name: "作业管理",
          icon: "/icon/zuoye.png",
          subName: "Precision Diagnosis",
        },
        {
          path: "/report",
          name: "报告管理",
          icon: "/icon/xingzhuang.png",
          subName: "Precision Diagnosis",
        },
        {
          path: "/sufferer",
          name: "患者管理",
          icon: "/icon/huanzhe2.png",
          subName: "Precision Diagnosis",
        },
        {
          path: "/sample",
          name: "样本管理",
          icon: "/icon/yangbenguanli.png",
          subName: "Precision Diagnosis",
        },
        {
          path: "/turn/user",
          name: "总控设置",
          icon: "/icon/shezhi-4.png",
          subName: "Precision Diagnosis",
        },
        {
          path: "/molecular",
          name: "Database",
          icon: "/icon/database-icon.png",
          subName: "Genemics Database",
        },
      ],
    };
  },
  created() {
    if (!authUtils.auth("10903") && authUtils.auth("10904")) {
      this.barType = "report";
    }
    if (!authUtils.auth("10901") && authUtils.auth("10902")) {
      this.areaType = "report";
    }
  },
  mounted() {
    this.initMenus();
    this.getNoteData();
    this.getHomePageStat();
    this.getMTData();
    this.getStatusStat();
    this.getReportAndTreatment();
  },
  methods: {
    initMenus() {
      const userMenus = this.$db.get("userMenusAllMenus");
      if (userMenus.length) {
        this.allMenus.forEach((item) => {
          let isHave = userMenus.find((d) => d.name == item.name);
          if (isHave) {
            if (item.name == "总控设置") {
              item.path =
                isHave.children.length > 0 ? isHave.children[0].path : "/404";
            }
            this.menus.push(item);
          }
        });
      }
    },
    /**
     * 新增就诊流程 && 已通过的报告 => 波浪图
     */
    getReportAndTreatment() {
      this.$get("/stat/statPatientItemAndReportNumByDate", this.statOpt).then(
        (res) => {
          this.reportAndTreatmentData = res.data.data;
          if (Object.keys(this.reportAndTreatmentData).length !== 0) {
            this.reportNumArea = this.formatAreaData(
              this.reportAndTreatmentData.reportNums
            );
            this.diagnosisNumArea = this.formatAreaData(
              this.reportAndTreatmentData.itemNums
            );
          }
          this.flagArea = false;
        }
      );
    },
    /**
     * 新增就诊流程 && 已通过的报告 => 波浪图-格式化数据
     */
    formatAreaData(data) {
      let that = this,
        result = {},
        xAxis = [],
        areaData = [];
      if (data.length > 0) {
        data.forEach((item, i) => {
          xAxis.push(item.createTime);
          areaData.push(item.num);
        });
      }
      result = { xAxis: xAxis, areaData: areaData };
      return result;
    },
    /**
     * 我的报告 && 我的就诊流程 => 柱状图
     */
    getStatusStat() {
      this.flagBar = false;
      this.$get("/patientitem/patientItem/getStatusStat").then((res) => {
        this.itemStatusData = res.data.data;
        this.reportStatusDataBar = this.formatBarData(
          this.itemStatusData.report,
          this.itemReportStatusName
        );
        this.diagnosisStatusDataBar = this.formatBarData(
          this.itemStatusData.item,
          this.itemDiagnosisStatusName
        );
      });
    },
    /**
     * 我的报告 && 我的就诊流程 => 柱状图-格式化数据
     */
    formatBarData(data, keyNameData) {
      let that = this,
        result = {},
        yAxis = [],
        barData = [];
      if (Object.keys(data).length !== 0) {
        for (let k in keyNameData) {
          yAxis.push(keyNameData[k]);
          barData.push({
            value: data[k],
            name: k,
            text: keyNameData[k],
            itemStyle: {
              color: "#428EF7",
            },
            label: {
              color: "#428EF7",
              show: true,
              precision: 1,
              position: "right",
              valueAnimation: true,
              fontFamily: "Arial",
              fontSize: 14,
            },
          });
        }
      }
      result = { yAxis: yAxis, barData: barData };
      return result;
    },
    getMTData() {
      let that = this;
      this.$get("/mt/q/pd").then((res) => {
        this.piesData = res.data.data.pies;
      });
    },
    getHomePageStat() {
      this.$get("/report/report/getHomePageStat").then((res) => {
        this.pageStatData = res.data.data;
      });
    },
    goToUserPage(url) {
      if (url && url.indexOf("http") != -1) {
        const openUrl = process.env.VUE_APP_BLANK_UEC_URL;
        window.open(openUrl);
      } else if (url) {
        this.$router.push(url);
      } else {
        this.$message.warning("正在努力的开发中，请耐心等待！");
      }
    },
    getNoteData() {
      let userid = this.$db.get("userInfo").userId;
      this.$get("/message/page", {
        pageSize: 6,
        pageNum: 1,
        userId: userid,
        optTimeRange: 0,
        messageStatus: 0,
      }).then((res) => {
        this.noteData = res.data.data.rows;
        this.noteTotal = res.data.data.total;
      });
    },
    setRead(ids) {
      if (ids) {
        this.$put("/message", {
          ids: ids,
        }).then((res) => {
          console.log("消息通知已读成功");
        });
      }
    },
    message(item) {
      if (item) {
        if (item.messageTitleType) {
          if (item.messageTitleType) {
            this.setRead(item.id);
            if (item.messageTitleType == 13) {
              this.$router.push({
                path: "/sufferer",
              });
            } else if (
              item.messageTitleType == 2 ||
              item.messageTitleType == 4 ||
              item.messageTitleType == 5 ||
              item.messageTitleType == 17 ||
              item.messageTitleType == 19 ||
              item.messageTitleType == 20
            ) {
              this.$router.push({
                path: "/diagnosis/details",
                query: {
                  id: item.bid,
                },
              });
            } else if (item.messageTitleType == 6) {
              this.$router.push({
                path: "/sample",
              });
            } else if (
              item.messageTitleType == 7 ||
              item.messageTitleType == 8 ||
              item.messageTitleType == 15 ||
              item.messageTitleType == 21
            ) {
              this.$router.push({
                path: "/job/details",
                query: {
                  id: item.bid,
                },
              });
            } else if (
              item.messageTitleType == 9 ||
              item.messageTitleType == 10 ||
              item.messageTitleType == 11 ||
              item.messageTitleType == 12 ||
              item.messageTitleType == 16
            ) {
              this.$router.push({
                path: "/report/details",
                query: {
                  id: item.bid,
                },
              });
            } else if (item.messageTitleType == 3) {
              this.$router.push({
                path: "/sufferer/detail",
                query: {
                  id: item.bid,
                },
              });
            }
          }
        }
      }
    },
    // 截取字符串
    mdMessageContentHtml(item) {
      let splitContent = item.messageContent
        ? item.messageContent.split("#$%")
        : [];
      let resultStr = "";
      if (item.messageTitleType == 22) {
        resultStr =
          "MD审核了协助组条码为" +
          splitContent[0] +
          "的样本：" +
          splitContent[1];
      } else {
        resultStr =
          splitContent[0] +
          "回了MD审核：" +
          splitContent[1] +
          ";“" +
          splitContent[2] +
          "“";
      }
      return resultStr;
    },
    onChangePicker(val, dateString) {
      if (dateString.length > 0) {
        this.rPrckerVal = val;
        let statOpt = {
          startTime: dateString[0],
          endTime: dateString[1],
        };
        this.statOpt = Object.assign({}, this.statOpt, statOpt);
        this.flagArea = true;
      }
      this.getReportAndTreatment();
    },
    disabledEndDate(current) {
      return current && current > moment().endOf("day");
    },
    tabsChartArea(param) {
      this.areaType = param;
    },
    tabsChartBar(param) {
      this.barType = param;
    },
  },
};
</script>

<style lang="scss" scoped>
.tdi-link {
  cursor: pointer;
}

.t-d-i-header {
  background: #020305;
}

.t-d-i-content {
  width: 100%;
  margin: 0 auto;
}

.tdw-top {
  padding: 10px 20px;
  .tdw-t-name {
    font-size: 22px;
    color: #162232;
    line-height: 30px;
  }
  .tdw-t-info {
    font-size: 12px;
    color: #9b9b9b;
    line-height: 17px;
    .tdw-tinfo-c {
      color: #222222;
    }
  }
  .tdw-t-navb {
    margin-top: 5px;
    width: 48px;
    height: 48px;
    background: #ffffff;
    border-radius: 12px;
    display: inline-block;
    margin-right: 10px;
    text-align: center;
    padding: 10px 10px;
    cursor: pointer;
    &.tdw-t-navbgc {
      background-color: #47a5a5;
    }
  }
  .tdw-t-useropt {
    width: 80px;
    // margin-right: 45px;
    /deep/ .ant-btn-primary {
      height: 27px;
      font-size: 12px;
      border-radius: 1px;
      background-color: #fff;
      border: 1px solid #428ef7;
      color: #428ef7;
      margin-top: 8px;
      &:hover {
        background-color: #428ef7;
        color: #fff;
      }
    }
  }
  .tdw-t-userinfo {
    width: 200px;
    .tdw-t-name {
      padding-bottom: 6px;
    }
    .tdw-t-info {
      margin-top: 8px;
      width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
.tdw-t-navb,
.tdw-content-top .tdw-icon {
  .icon {
    display: block;
    height: 28px;
    width: 28px;
    font-size: 28px;
    color: #333;
    -webkit-transition: font-size 0.25s linear, width 0.25s linear;
    -moz-transition: font-size 0.25s linear, width 0.25s linear;
    transition: font-size 0.25s linear, width 0.25s linear;
  }
  .svg-icon {
    width: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
}
.tdw-content {
  background-color: #fff;
  padding-bottom: 30px;
  .tdw-content-top {
    border-bottom: 1px solid #efefef;
    margin-bottom: 5px;
    .tdw-icon {
      display: inline-block;
      vertical-align: middle;
      margin-right: 3px;
    }
    .tdw-c-statistics,
    .tdw-c-database {
      width: 50%;
      text-align: center;
      padding: 15px 0;
    }
    .tdw-c-statistics {
      border-right: 1px solid #efefef;
    }
    .tdw-cs-name {
      color: #646464;
      font-size: 18px;
      line-height: 25px;
    }
    .tdw-cs-info {
      font-size: 12px;
      color: #9b9b9b;
      line-height: 17px;
      &.tdw-cs-info-h {
        height: 24px;
      }
      .tdw-cs-num {
        font-size: 24px;
        font-weight: bolder;
        color: #646464;
        line-height: 33px;
        vertical-align: middle;
      }
    }
    .tdw-cs-line {
      width: 2px;
      height: 29px;
      border-right: 2px solid #efefef;
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -15px;
    }
    .tdw-cs-db-layer {
      padding-right: 20px;
      .tdw-cs-name {
        font-size: 14px;
        line-height: 20px;
      }
      .tdw-cs-info {
        line-height: 12px;
      }
      .tdw-cs-info-dbnum {
        font-size: 16px;
        font-weight: bolder;
        line-height: 22px;
      }
    }
  }

  .tdw-content-center {
    padding: 8px 20px;
  }
  .tdw-cc-left {
    border: 1px solid #f0f2f5;
    padding: 0 12px;
    padding-bottom: 9px;
    margin-right: 7.5px;
    min-height: 256px;
    /deep/ .ant-empty-image,
    /deep/ .ant-empty-description {
      display: block;
    }
    &.tdw-cc-left-height {
      height: 266px;
    }
    .cursor {
      &.cursor-adline {
        .tdw-cc-row {
          text-decoration-line: underline;
        }
      }
    }
  }
  .tdw-cc-right {
    border: 1px solid #f0f2f5;
    padding: 0 12px;
    margin-left: 7.5px;
    min-height: 256px;
  }
  .tdw-cc-charts-main {
    width: 100%;
    height: 192px;
    margin-bottom: 15px;
    /deep/ .ant-empty-image,
    /deep/ .ant-empty-description {
      display: block;
    }
  }
  .tdw-cc-row {
    overflow: hidden;
    white-space: nowrap;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
  }
  .tdw-cc-t-title {
    padding: 9px 0;
    font-size: 14px;
    font-weight: 600;
    color: #646464;
    line-height: 20px;
    .link {
      font-size: 12px;
      em {
        font-family: "宋体";
        font-style: initial;
      }
    }
    &.tdw-cc-tnav {
      padding-bottom: 0;
    }
    span {
      margin-left: 5px;
    }
    span.tdw-cc-check {
      margin-right: 15px;
      display: inline-block;
      cursor: pointer;
      &.not-checked {
        font-weight: initial;
      }
    }
  }
  .tdw-cc-tlist {
    font-size: 14px;
    font-weight: 400;
    color: #646464;
    line-height: 20px;
    padding-bottom: 15px;
  }
  .tdw-cc-time {
    font-size: 14px;
    color: #9b9b9b;
    line-height: 20px;
    text-align: center;
  }
  .tdw-table {
    margin-bottom: 20px;
    /deep/ .ant-table-small {
      border-radius: 0;
    }
    /deep/ .ant-table-body {
      margin: 0 0;
    }
    /deep/ .ant-table-thead {
      background: #f5f9fe;
      border: 1px solid #f0f2f5;
      tr > th {
        border-right: 0;
      }
    }
    /deep/ .ant-table-tbody {
      tr > td {
        border-right: 0;
      }
    }
  }
  .tdw-list-progress {
    margin: 19px 10px;
    .tdw-list-progress-name {
      font-size: 12px;
      line-height: 16px;
    }
  }
}
</style>